import Utils from './utils';

export default class GlobalAlert {
    private alertRibbonContainer: HTMLElement;
    private dismissBtn: HTMLButtonElement;
    private cookieID: string;

    constructor(cookieIdentifier: string) {
        this.alertRibbonContainer = document.querySelector(".alert-ribbon-section");
        if (!this.alertRibbonContainer) return;
        this.cookieID = cookieIdentifier;
        this.initialise();
    }

    private initialise() {
        this.dismissBtn = this.alertRibbonContainer.querySelector<HTMLButtonElement>(".dismiss-button");
        if (Utils.GetCookie(this.cookieID) === "true") {
            this.hideAlert();
        } else {
            this.showAlert();
        }
        this.dismissBtn.addEventListener("click", () => {
            Utils.SetCookie(this.cookieID, "true", 7)
            this.hideAlert()
        })


        window.addEventListener('resize', () => {
            this.updateHeaderHeight();
        })
    }
    private showAlert() {
        this.alertRibbonContainer.classList.add("show");
        this.updateHeaderHeight();
    }
    private hideAlert() {
        this.alertRibbonContainer?.classList.remove("show");
        document.documentElement.style.setProperty("--alert-ribbon-height", "0px");
    }

    private updateHeaderHeight() {
        const updatedHeight = this.alertRibbonContainer.clientHeight;
        if (!this.alertRibbonContainer.classList.contains("show"))
            return;
        if (window.innerWidth < 992) {
            document.documentElement.style.setProperty("--alert-ribbon-height", updatedHeight + "px");
        } else {
            document.documentElement.style.setProperty("--alert-ribbon-height", "40px");
        }
    }
}